import { useNode } from "@craftjs/core";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ACCORDION_DROPDOWN_BUTTON_STYLE,
  BoxWidthTypes,
} from "../../../../constants/segmentTools";
import { updateAccordionStyles } from "../../../../redux/reducers/PrevStylesCopy/CodeblockDefaultStyles";
import { opacityToSlider, sliderToOpacity } from "../../../../utils/helpers";
import FroalaTextEditor from "../../../FroalaEditor/children/FroalaTextEditor";
import SegmentIcon from "../../../SegmentSettings/children/SegmentIcon";
import ColorPopup from "../../Shared/ColorPopup";
import MarginBox from "../../Shared/MarginBox";
import SettingsSlider from "../../Shared/SettingsSlider";
import SizeBox from "../../Shared/SizeBoxes";
import AccordionRightDropDown from "./AccordionRightDropDown";

const AccordionSettings = () => {
  const {
    actions: { setProp },
    header,
    expanded,
    margin,
    isApplyMarginOnAllSides,
    allSideMargin,
    borderColor,
    borderWidth,
    borderRadius,
    headerBgColor,
    headerTextColor,
    contentBgColor,
    contentTextColor,
    selectedBoxSizeId,
    dropDownRightIcon,
    dropDownIconColor,
    headerOpacity,
    contentOpacity,
    dropShadowColor,
    selectedIcon,
  } = useNode((node) => ({
    header: node.data.props.header,
    expanded: node.data.props.expanded,
    margin: node.data.props.margin,
    isApplyMarginOnAllSides: node.data.props.isApplyMarginOnAllSides,
    allSideMargin: node.data.props.allSideMargin,
    borderColor: node.data.props.borderColor,
    borderWidth: node.data.props.borderWidth,
    borderRadius: node.data.props.borderRadius,
    headerBgColor: node.data.props.headerBgColor,
    headerTextColor: node.data.props.headerTextColor,
    contentBgColor: node.data.props.contentBgColor,
    contentTextColor: node.data.props.contentTextColor,
    selectedBoxSizeId: node.data.props.selectedBoxSizeId,
    dropDownRightIcon: node.data.props.dropDownRightIcon,
    dropDownIconColor: node.data.props.dropDownIconColor,
    headerOpacity: node.data.props.headerOpacity,
    contentOpacity: node.data.props.contentOpacity,
    dropShadowColor: node.data.props.dropShadowColor,
    selectedIcon: node.data.props.selectedIcon,
  }));

  const dispatch = useDispatch();
  const { accordion: accordionProps } = useSelector(
    (state) => state.codeblockStyles
  );

  // useEffect(() => {
  //   // When the component mounts, update the accordionProps in Redux
  //   const updatedAccordionProps = {
  //     ...accordionProps,
  //     header: header || accordionProps.header,
  //     expanded: expanded,
  //     margin: margin || accordionProps.margin,
  //     isApplyMarginOnAllSides: isApplyMarginOnAllSides,
  //     allSideMargin: allSideMargin || accordionProps.allSideMargin,
  //     borderRadius: borderRadius || accordionProps.borderRadius,
  //     borderWidth: borderWidth || accordionProps.borderWidth,
  //     borderColor: borderColor || accordionProps.borderColor,
  //     dropShadowColor: dropShadowColor || accordionProps.dropShadowColor,
  //     headerBgColor: headerBgColor || accordionProps.headerBgColor,
  //     headerTextColor: headerTextColor || accordionProps.headerTextColor,
  //     contentBgColor: contentBgColor || accordionProps.contentBgColor,
  //     contentTextColor: contentTextColor || accordionProps.contentTextColor,
  //     selectedBoxSizeId: selectedBoxSizeId || accordionProps.selectedBoxSizeId,
  //     dropDownRightIcon: dropDownRightIcon !== undefined ? dropDownRightIcon : accordionProps.dropDownRightIcon,
  //     headerOpacity: headerOpacity !== undefined ? headerOpacity : accordionProps.headerOpacity,
  //     contentOpacity: contentOpacity !== undefined ? contentOpacity : accordionProps.contentOpacity,
  //     selectedIcon: selectedIcon || accordionProps.selectedIcon
  //   };

  //   // Dispatch to update the global accordion props
  //   dispatch(updateAccordionStyles(updatedAccordionProps));
  // }, []);

  const handleAdjustment = (side, operation) => {
    const newValue =
      operation === "increase" ? margin[side] + 1 : margin[side] - 1;
    if (newValue >= 0) handleChange("margin", newValue, side);
  };

  const editorRef = useRef(null);

  const handleChange = (type, value, side) => {
    setProp((props) => {
      switch (type) {
        case "margin":
          if (value >= 0 && value <= 100) props.margin[side] = value;
          break;
        case "allSideMargin":
          props.allSideMargin = value;
          break;
        case "marginCheckbox":
          props.isApplyMarginOnAllSides = !props.isApplyMarginOnAllSides;
          break;
        case "headerBgColor":
          props.headerBgColor = value;
          break;
        case "contentBgColor":
          props.contentBgColor = value;
          break;
        case "resetHeaderBgColor":
          props.headerBgColor = "#D4E2F2";
          break;
        case "resetContentBgColor":
          props.contentBgColor = "#F7F2FA";
          break;
        case "headerOpacity":
          props.headerOpacity = sliderToOpacity(value);
          break;
        case "borderRadius":
          props.borderRadius = value;
          break;
        case "contentOpacity":
          props.contentOpacity = sliderToOpacity(value);
          break;
        case "borderColor":
          props.borderColor = value;
          break;
        case "borderWidth":
          props.borderWidth = value;
          break;
        case "dropShadowColor":
          props.dropShadowColor = value;
          break;
        case "resetColor":
          props.borderColor = null;
          break;
        case "resetShadow":
          props.dropShadowColor = null;
          break;
        case "selectedIcon":
          props.selectedIcon = value;
          break;
        case "dropDownIconColor":
          props.dropDownIconColor = value;
          break;
        case "resetDropDownIconColor":
          props.dropDownIconColor = "#FFFFFF";
          break;
        default:
          break;
      }
    }, 500);

    // Update Redux state
    const updatedAccordionProps = { ...accordionProps };

    switch (type) {
      case "margin":
        if (side && value >= 0 && value <= 100) {
          updatedAccordionProps.margin = {
            ...updatedAccordionProps.margin,
            [side]: value,
          };
        }
        break;
      case "allSideMargin":
        updatedAccordionProps.allSideMargin = value;
        break;
      case "marginCheckbox":
        updatedAccordionProps.isApplyMarginOnAllSides =
          !isApplyMarginOnAllSides;
        break;
      case "headerBgColor":
        updatedAccordionProps.headerBgColor = value;
        break;
      case "contentBgColor":
        updatedAccordionProps.contentBgColor = value;
        break;
      case "resetHeaderBgColor":
        updatedAccordionProps.headerBgColor = "#D4E2F2";
        break;
      case "resetContentBgColor":
        updatedAccordionProps.contentBgColor = "#F7F2FA";
        break;
      case "headerOpacity":
        updatedAccordionProps.headerOpacity = sliderToOpacity(value);
        break;
      case "borderRadius":
        updatedAccordionProps.borderRadius = value;
        break;
      case "contentOpacity":
        updatedAccordionProps.contentOpacity = sliderToOpacity(value);
        break;
      case "borderColor":
        updatedAccordionProps.borderColor = value;
        break;
      case "borderWidth":
        updatedAccordionProps.borderWidth = value;
        break;
      case "dropShadowColor":
        updatedAccordionProps.dropShadowColor = value;
        break;
      case "resetColor":
        updatedAccordionProps.borderColor = null;
        break;
      case "resetShadow":
        updatedAccordionProps.dropShadowColor = null;
        break;
      case "selectedIcon":
        updatedAccordionProps.selectedIcon = value;
        break;
      case "dropDownIconColor":
        updatedAccordionProps.dropDownIconColor = value;
        break;
      case "resetDropDownIconColor":
        updatedAccordionProps.dropDownIconColor = "#FFFFFF";
        break;
    }

    dispatch(updateAccordionStyles(updatedAccordionProps));
  };

  const handleBoxSelect = (selectedBoxId) => {
    setProp((props) => {
      if (selectedBoxId === BoxWidthTypes.FullWidth.id) {
        props.margin = { ...props.margin, left: 0, right: 0 };
      } else {
        props.margin = { ...props.margin, left: 10, right: 10 };
      }
      props.selectedBoxSizeId = selectedBoxId;
    });

    // Update Redux state
    const updatedAccordionProps = { ...accordionProps };
    if (selectedBoxId === BoxWidthTypes.FullWidth.id) {
      updatedAccordionProps.margin = {
        ...updatedAccordionProps.margin,
        left: 0,
        right: 0,
      };
    } else {
      updatedAccordionProps.margin = {
        ...updatedAccordionProps.margin,
        left: 10,
        right: 10,
      };
    }
    updatedAccordionProps.selectedBoxSizeId = selectedBoxId;
    dispatch(updateAccordionStyles(updatedAccordionProps));
  };

  const handleDropDownitemSelect = (id) => {
    setProp((props) => (props.dropDownRightIcon = id));

    // Update Redux state
    const updatedAccordionProps = { ...accordionProps };
    updatedAccordionProps.dropDownRightIcon = id;
    dispatch(updateAccordionStyles(updatedAccordionProps));
  };

  return (
    <div>
      {/* <SegmentHeader title="Accordion" handleDeleteSegment={() => {}} /> */}

      <SizeBox
        data={[
          {
            id: BoxWidthTypes.ContentWidth.id,
            title: "Box Size",
            image: BoxWidthTypes.ContentWidth.image,
          },
          {
            id: BoxWidthTypes.FullWidth.id,
            title: "Full Width",
            image: BoxWidthTypes.FullWidth.image,
          },
        ]}
        selectedItem={selectedBoxSizeId}
        onBoxSelect={handleBoxSelect}
        title="Box Size"
      />

      <FroalaTextEditor
        editorHeight={"80px"}
        name={"text_body_1"}
        id={1}
        value={header}
        onChange={(model) => {
          setProp((props) => {
            if (model) {
              return (props.header = model);
            }
          });

          // Update Redux state
          // if (model) {
          //   const updatedAccordionProps = { ...accordionProps };
          //   updatedAccordionProps.header = model;
          //   dispatch(updateAccordionStyles(updatedAccordionProps));
          // }
        }}
        editorRef={editorRef}
        label={"Title Text"}
        toolbarButtons={[
          "fontFamily",
          "fontSize",
          "textColorCustom",
          "bold",
          "italic",
          "underline",
          "emoticons",
          "specialCharacters",
        ]}
        type="title"
        characters="40"
      />

      <AccordionRightDropDown
        title="Dropdown Button Style"
        items={ACCORDION_DROPDOWN_BUTTON_STYLE}
        selectedItemId={dropDownRightIcon}
        handleItemSelect={handleDropDownitemSelect}
      />

      <ColorPopup
        title="Dropdown Button Color"
        background={dropDownIconColor ?? "#FFFFFF"}
        handleChangeBackgroundColor={(val) =>
          handleChange("dropDownIconColor", val)
        }
        resetBackgroundColor={() =>
          handleChange("resetDropDownIconColor", null, null)
        }
        showSlider={false}
        isHideGradient={true}
        showSuggestedColorPalette={true}
      />

      {/* <SegmentIcon
        selectedIcon={selectedIcon}
        onIconSelect={(icon) => {
          handleChange('selectedIcon', icon);
        }}
        title="Accordion Icon"
      /> */}

      <MarginBox
        margin={margin}
        increaseMargin={(side) => handleAdjustment(side, "increase")}
        decreaseMargin={(side) => handleAdjustment(side, "decrease")}
        isApplyMarginOnAllSides={isApplyMarginOnAllSides}
        handleMarginCheckBox={() => handleChange("marginCheckbox")}
        allSideMargin={allSideMargin}
        handleSliderMarginChange={(value) =>
          handleChange("allSideMargin", value)
        }
        handleMarginChange={(side, newValue) =>
          handleChange("margin", newValue, side)
        }
      />

      <SettingsSlider
        title="Corner Rounding"
        sliderValue={borderRadius}
        onValueChange={(val) => handleChange("borderRadius", val)}
        min={1}
      />

      <ColorPopup
        title="Title Background"
        background={headerBgColor}
        handleChangeBackgroundColor={(val) =>
          handleChange("headerBgColor", val)
        }
        resetBackgroundColor={() => handleChange("resetHeaderBgColor")}
        sliderValue={opacityToSlider(headerOpacity)}
        sliderChange={(val) => handleChange("headerOpacity", val)}
        sliderBoxTitle={"Opacity"}
        showSuggestedColorPalette={true}
      />

      <ColorPopup
        title="Content Background"
        background={contentBgColor}
        handleChangeBackgroundColor={(val) =>
          handleChange("contentBgColor", val)
        }
        resetBackgroundColor={() => handleChange("resetContentBgColor")}
        sliderValue={opacityToSlider(contentOpacity)}
        sliderChange={(val) => handleChange("contentOpacity", val)}
        sliderBoxTitle={"Opacity"}
        showSuggestedColorPalette={true}
      />

      <ColorPopup
        title="Border"
        background={borderColor}
        handleChangeBackgroundColor={(val) => handleChange("borderColor", val)}
        resetBackgroundColor={() => handleChange("resetColor", null, null)}
        sliderBoxTitle={"Border Width"}
        sliderValue={borderWidth}
        sliderChange={(val) => handleChange("borderWidth", val)}
        sliderMinValue={0}
        sliderMaxValue={8}
        sliderSymbol={"px"}
        isHideGradient={true}
        showSuggestedColorPalette={true}
        isBorderSlider
      />

      <ColorPopup
        title="Drop Shadow"
        background={dropShadowColor}
        handleChangeBackgroundColor={(val) =>
          handleChange("dropShadowColor", val)
        }
        resetBackgroundColor={() => handleChange("resetShadow", null, null)}
        showSlider={false}
        isHideGradient={true}
        showSuggestedColorPalette={true}
      />
    </div>
  );
};

export default AccordionSettings;
